export const PROBLEM_ASSESSMENT_TYPE_MAPPING = {
  0: "Introduction",
  1: "Multiple Choice Question",
  2: "Multiple Select Question",
  3: "Short Answer Question",
  4: "Long Answer Question",
  5: "Numeric Answer Question",
  10: "Empty State",
  11: "Loader State",
  12: "Completed",
} as const

/**
 * Maps difficulty level number to string for API requests
 * -1 = All, 0 = Easy, 1 = Medium, 2 = Hard
 */
export const DIFFICULTY_TO_STRING: Record<number, string> = {
  [-1]: "all",
  0: "easy",
  1: "medium",
  2: "hard",
}

/**
 * Get difficulty string from numeric level
 */
export const getDifficultyString = (level: number): string => {
  return DIFFICULTY_TO_STRING[level] || "all"
}
